export enum SourceType {
  Event = 'event',
  NotEvent = 'not-event',
}
